import { render, staticRenderFns } from "./AsEmployeeInspectionStatusBadge.vue?vue&type=template&id=89c01918&scoped=true"
import script from "./AsEmployeeInspectionStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./AsEmployeeInspectionStatusBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsEmployeeInspectionStatusBadge.vue?vue&type=style&index=0&id=89c01918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c01918",
  null
  
)

export default component.exports